import React, { memo } from "react";
import PropTypes from "prop-types";
import * as types from "../../../../constants/ComponentConstants";

import { Popup } from 'semantic-ui-react';
import Table from "../../../common/Table";
import Row from "../../../common/Row";
import Marker from "../../../common/Marker";
import SportdienstStatusByGemeenteIcon from "../../../common/SportdienstStatusByGemeenteIcon";
import icoonErkendeClubsFeds from "../../../../images/IcoonErkendeClubsFeds.png";

const GemeenteOverzichtOrganisatiesForm = (props) => {
    const {
        sportclubModels,
        filter,
        totalPages,
        totalItems,
        onPageChange,
        onChangePageSize,
        onEditSportclub,
    } = props;

    const infoPopup =
        <div>
            <p>Sport Vlaanderen gebruikt een getrapt systeem (cascadeprincipe) met de adressen van een sportclub om te bepalen tot welke gemeente(n) een sportclub behoort.</p><br />
            <ol type="1">
                <li><p>Als een sportclub gebruikt maakt van een infrastructuur in een gemeente, dan wordt ze bij die gemeente geteld. De sportclub kan dus ook bij meerdere gemeenten horen indien ze infrastructuren van meerdere gemeenten gebruikt. Indien omwille van specifieke redenen de sportinfrastructuur niet gekend is bij Sport Vlaanderen wordt het exploitatie-adres gebruikt.</p></li>
                <li><p>Als een sportclub geen infrastructuur gebruikt, dan wordt bij de adressen die gekoppeld zijn aan de sportclub, op basis van 1 of meerdere correspondentie-adressen bepaald tot welke gemeente(n) de sportclub behoort. Voorbeelden van sportclubs die niet gebruik maken van een vaste trainingsinfrastructuur zijn bv. wielerclubs, wandelclubs, joggingclubs, ...</p></li>
                <li><p>Indien een sportclub geen correspondentie-adres heeft, wordt de maatschappelijke zetel genomen om te bepalen tot welke gemeente een sportclub behoort</p></li>
                <li><p>Indien geen van bovenstaande van toepassing is, dan wordt een sportclub gekoppeld aan het adres van de gemeentelijke sportdienst</p></li>
            </ol>
        </div>;

    function handleOnEditSportclub(id, isNew, isReadonly) {
        return function () {
            onEditSportclub(id, isNew, isReadonly);
        };
    }

    const tdStyle = { padding: "5px" };
    const tdWithMarkerStyle = { display: "flex", alignItems: "baseline", padding: "5px" };
    function returnTdContent(text, maxLength) {
        return text.length > maxLength ? <Popup wide="very" position="top left" trigger={<p>{text.substring(0, maxLength) + "..."}</p>} content={text} /> : text;
    }

    function returnErkendDoorTdContent(club) {
        if(club.isGesubsidieerdDoorOverheid)
            return <Popup wide="very" trigger={<div><SportdienstStatusByGemeenteIcon type={types.ICON_GESUBSIDIEERDDOOR} /></div>} content={"Deze sportclub is door de gemeente erkend en gesubsidieerd"} />;

        if(club.isErkendDoorSportdienst)
            return <Popup wide="very" trigger={<div><SportdienstStatusByGemeenteIcon type={types.ICON_ERKENDDOORGEMEENTE} /></div>} content={"Deze sportclub is door de gemeente erkend"} />;

            return null;
    }

    function getActions(club) {
        return (
            <td style={{ paddingBottom: '2px', paddingTop: '2px' }}>
                {club.transactionType === "Unlink" ? null :
                    club.status === "In Behandeling" ?
                        <Popup wide="very" trigger={<i className="fa fa-eye" style={{ cursor: 'pointer', "margin": "0 5px" }} onClick={handleOnEditSportclub(club.id, false, true)} />} content={"Toon detail sportclub. Je kan deze sportclub niet wijzigen omdat Sport Vlaanderen momenteel een wijzigingsaanvraag van deze sportclub verwerkt."} position="left center" /> :
                        <Popup wide="very" trigger={<i className="fa fa-pencil" style={{ cursor: 'pointer', "margin": "0 5px" }} onClick={handleOnEditSportclub(club.id, false, false)} />} content={"Bekijk detail/ wijzig sportclub"} position="left center" />}
            </td>
        );
    }

    function watervalPrio(adresWatervalType) {
        switch (adresWatervalType) {
            case 0:
                return "Sportinfrastructuur";
            case 1:
                return "Exploitatieadres";
            case 2:
                return "Correspondentieadres";
            case 3:
                return "Maatschappelijke zetel";
            case 4:
            default:
                return "Gemeente waartoe sportclub behoort";
        }
    }

    function watervalColor(adresWatervalType) {
        switch (adresWatervalType) {
            case 0:
                return types.COLOR_ORANGE;
            case 1:
                return types.COLOR_RED;
            case 2:
                return types.COLOR_BLUE;
            case 3:
                return types.COLOR_GREEN;
            case 4:
            default:
                return types.COLOR_BLACK;
        }
    }

    const clubRows = sportclubModels.map((club, i) => {
        const clubNaam = club.name + (club.afkorting ? " (" + club.afkorting + ")" : "");
        let sporttakken = club.alleSporttakken ? club.alleSporttakken.replace(/{/g, '').replace(/}/g, ', ') : "";
        if (sporttakken) sporttakken = sporttakken.substring(0, sporttakken.length - 2);
        return (<tr className={club.transactionType === "Unlink" ? 'crossedText' : null} style={{ borderStyle: 'solid', borderWidth: "1px", borderColor: '#eeefef', height: '100%' }} key={i} height="80" >
            <td style={tdStyle}>{returnTdContent(clubNaam, 27)}</td>
            <td style={tdStyle}>{returnErkendDoorTdContent(club, 27)}</td>
            <td style={tdStyle}>{club.erkend ? <Popup wide="very" trigger={<img style={{ "height": "1.5rem" }} src={icoonErkendeClubsFeds} />} content={"Deze sportclub is lid van een erkende Vlaamse sportfederatie"} /> : null}</td>
            <td style={tdWithMarkerStyle}>
                {returnTdContent(watervalPrio(club.adresWatervalType), 23)}
                <Marker onMap={false} size={0.75} color={watervalColor(club.adresWatervalType)} />
            </td>
            <td style={tdStyle}>{returnTdContent(sporttakken, 20)}</td>
            <td style={tdStyle}>{club.alleSportDomeinNamen ? returnTdContent(club.alleSportDomeinNamen, 20) : null}</td>
            <td style={tdStyle}>{returnTdContent(club.actief ? 'Actief' : 'Inactief', 27)}</td>
            {getActions(club)}
        </tr >);
    });

    return (
        <div className="o-col-12">
            <Row>
                {
                    totalItems > 0 ?
                        <div>
                            <div className="o-col-9">
                                <h1 style={{ color: 'rgb(57, 180, 232)', display: "contents" }} >{totalItems + " sportclubs gevonden in jouw gemeente"}</h1>
                                <Popup wide="very" trigger={<i className="fa fa-info-circle" style={{ cursor: 'pointer', "margin": "0 5px", color: 'rgb(57, 180, 232)' }} />} content={infoPopup} position="left center" />
                            </div>
                            <Table
                                headers={["Naam (Afkorting)","", "", "Behoort tot gemeente o.b.v.", "Sporttak", "Sportdomein", "Actief", ""]}
                                headerSizes={[25, 3, 3, 25, 20, 20, 7]}
                                activePage={filter.pageNo}
                                pageSize={filter.pageSize}
                                totalPages={totalPages}
                                onPageChange={onPageChange}
                                changePageSize={onChangePageSize}
                                totalItems={totalItems}
                            >
                                {clubRows}
                            </Table>
                        </div>
                        :
                        <p style={{ margin: "15px 0" }}>Geen sportclubs gevonden die voldoen aan de opgegeven zoekcriteria.</p>}
            </Row>
        </div>
    );
};

GemeenteOverzichtOrganisatiesForm.propTypes = {
    sportclubModels: PropTypes.array,
    filterHasValidPoId: PropTypes.bool,
    onChangePageSize: PropTypes.func,
    filter: PropTypes.object,
    totalItems: PropTypes.number,
    totalPages: PropTypes.number,
    onPageChange: PropTypes.func,
    onEditSportclub: PropTypes.func,
};

export default GemeenteOverzichtOrganisatiesForm;